// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/iam/v1/external_clients.proto" (package "c1.api.iam.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { UserRef } from "../../user/v1/user";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.iam.v1.GetApprovalInfoRequest
 */
export interface GetApprovalInfoRequest {
    /**
     * Encrypted DCRApprovalState token from /approve-client query param
     *
     * @generated from protobuf field: string state = 1;
     */
    state: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.GetApprovalInfoResponse
 */
export interface GetApprovalInfoResponse {
    /**
     * Client name from registration metadata
     *
     * @generated from protobuf field: string client_name = 1;
     */
    clientName: string;
    /**
     * Redirect URI the client will return to
     *
     * @generated from protobuf field: string redirect_uri = 2;
     */
    redirectUri: string;
    /**
     * Well-known client classification - frontend maps to icon and vendor string
     *
     * @generated from protobuf field: c1.api.iam.v1.WellKnownClient well_known_client = 3;
     */
    wellKnownClient: WellKnownClient;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ApproveRequest
 */
export interface ApproveRequest {
    /**
     * Encrypted DCRApprovalState token
     *
     * @generated from protobuf field: string state = 1;
     */
    state: string;
    /**
     * Role IDs the user selected to grant
     *
     * @generated from protobuf field: repeated string selected_role_ids = 2;
     */
    selectedRoleIds: string[];
    /**
     * Optional custom name for this connection (defaults to client_name if empty)
     *
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ApproveResponse
 */
export interface ApproveResponse {
    /**
     * Full redirect URL including authorization code and state
     *
     * @generated from protobuf field: string redirect_url = 1;
     */
    redirectUrl: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceListRequest
 */
export interface ExternalClientServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceListResponse
 */
export interface ExternalClientServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.iam.v1.ExternalClientInfo list = 1;
     */
    list: ExternalClientInfo[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * ExternalClientInfo provides information about an approved external client.
 * Used by both List (user's own grants) and Search (admin view of all grants).
 *
 * @generated from protobuf message c1.api.iam.v1.ExternalClientInfo
 */
export interface ExternalClientInfo {
    /**
     * OAuth2 client ID - canonical identifier for this connection (globally unique per DCR)
     *
     * @generated from protobuf field: string client_id = 1;
     */
    clientId: string;
    /**
     * The user who approved this external client (always populated)
     *
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * Original client name from DCR registration
     *
     * @generated from protobuf field: string client_name = 3;
     */
    clientName: string;
    /**
     * @generated from protobuf field: c1.api.iam.v1.WellKnownClient well_known_client = 4;
     */
    wellKnownClient: WellKnownClient;
    /**
     * Role IDs granted to this client - frontend can fetch display names via SearchRoles
     *
     * @generated from protobuf field: repeated string role_ids = 5;
     */
    roleIds: string[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 7;
     */
    lastUsedAt?: Timestamp;
    /**
     * User-provided custom name (defaults to client_name if not set)
     *
     * @generated from protobuf field: string display_name = 8;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceDeleteRequest
 */
export interface ExternalClientServiceDeleteRequest {
    /**
     * OAuth2 client ID to delete (globally unique per DCR registration)
     *
     * @generated from protobuf field: string client_id = 1;
     */
    clientId: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceDeleteResponse
 */
export interface ExternalClientServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceUpdateRequest
 */
export interface ExternalClientServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.iam.v1.ExternalClientInfo client = 1;
     */
    client?: ExternalClientInfo;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceUpdateResponse
 */
export interface ExternalClientServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.iam.v1.ExternalClientInfo client = 1;
     */
    client?: ExternalClientInfo;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientSearchServiceSearchRequest
 */
export interface ExternalClientSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Free-text search on client_name and user display name
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * Filter by specific user IDs
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef users = 4;
     */
    users: UserRef[];
    /**
     * Filter by well-known client type (e.g., CLAUDE_CODE, CURSOR, etc.)
     *
     * @generated from protobuf field: repeated c1.api.iam.v1.WellKnownClient well_known_clients = 5;
     */
    wellKnownClients: WellKnownClient[];
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientSearchServiceSearchResponse
 */
export interface ExternalClientSearchServiceSearchResponse {
    /**
     * Uses ExternalClientInfo with user_id populated for admin views
     *
     * @generated from protobuf field: repeated c1.api.iam.v1.ExternalClientInfo list = 1;
     */
    list: ExternalClientInfo[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * ExternalClientGrantRef is used for websocket notifications.
 *
 * @generated from protobuf message c1.api.iam.v1.ExternalClientGrantRef
 */
export interface ExternalClientGrantRef {
    /**
     * @generated from protobuf field: string client_id = 1;
     */
    clientId: string;
}
/**
 * WellKnownClient identifies recognized MCP client applications.
 * Used for UX (icons, vendor info). Values match c1.models.oauth.v1.WellKnownClient.
 *
 * @generated from protobuf enum c1.api.iam.v1.WellKnownClient
 */
export enum WellKnownClient {
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_UNKNOWN = 1;
     */
    UNKNOWN = 1,
    /**
     * Anthropic
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CLAUDE_AI = 2;
     */
    CLAUDE_AI = 2,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CLAUDE_DESKTOP = 3;
     */
    CLAUDE_DESKTOP = 3,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CLAUDE_CODE = 4;
     */
    CLAUDE_CODE = 4,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_MCP_INSPECTOR = 5;
     */
    MCP_INSPECTOR = 5,
    /**
     * OpenAI
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CHATGPT = 6;
     */
    CHATGPT = 6,
    /**
     * Microsoft
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_VSCODE = 7;
     */
    VSCODE = 7,
    /**
     * IDEs
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CURSOR = 10;
     */
    CURSOR = 10,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_WINDSURF = 11;
     */
    WINDSURF = 11,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_ZED = 12;
     */
    ZED = 12,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_JETBRAINS = 13;
     */
    JETBRAINS = 13,
    /**
     * Other
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_DOCKER_MCP_TOOLKIT = 15;
     */
    DOCKER_MCP_TOOLKIT = 15
}
// @generated message type with reflection information, may provide speed optimized methods
class GetApprovalInfoRequest$Type extends MessageType<GetApprovalInfoRequest> {
    constructor() {
        super("c1.api.iam.v1.GetApprovalInfoRequest", [
            { no: 1, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "8192" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.GetApprovalInfoRequest
 */
export const GetApprovalInfoRequest = new GetApprovalInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetApprovalInfoResponse$Type extends MessageType<GetApprovalInfoResponse> {
    constructor() {
        super("c1.api.iam.v1.GetApprovalInfoResponse", [
            { no: 1, name: "client_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "redirect_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "well_known_client", kind: "enum", T: () => ["c1.api.iam.v1.WellKnownClient", WellKnownClient, "WELL_KNOWN_CLIENT_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.GetApprovalInfoResponse
 */
export const GetApprovalInfoResponse = new GetApprovalInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApproveRequest$Type extends MessageType<ApproveRequest> {
    constructor() {
        super("c1.api.iam.v1.ApproveRequest", [
            { no: 1, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "8192" } } } },
            { no: 2, name: "selected_role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "100", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ApproveRequest
 */
export const ApproveRequest = new ApproveRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApproveResponse$Type extends MessageType<ApproveResponse> {
    constructor() {
        super("c1.api.iam.v1.ApproveResponse", [
            { no: 1, name: "redirect_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ApproveResponse
 */
export const ApproveResponse = new ApproveResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceListRequest$Type extends MessageType<ExternalClientServiceListRequest> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceListRequest
 */
export const ExternalClientServiceListRequest = new ExternalClientServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceListResponse$Type extends MessageType<ExternalClientServiceListResponse> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalClientInfo },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceListResponse
 */
export const ExternalClientServiceListResponse = new ExternalClientServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientInfo$Type extends MessageType<ExternalClientInfo> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientInfo", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "well_known_client", kind: "enum", T: () => ["c1.api.iam.v1.WellKnownClient", WellKnownClient, "WELL_KNOWN_CLIENT_"] },
            { no: 5, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "last_used_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientInfo
 */
export const ExternalClientInfo = new ExternalClientInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceDeleteRequest$Type extends MessageType<ExternalClientServiceDeleteRequest> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceDeleteRequest", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceDeleteRequest
 */
export const ExternalClientServiceDeleteRequest = new ExternalClientServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceDeleteResponse$Type extends MessageType<ExternalClientServiceDeleteResponse> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceDeleteResponse
 */
export const ExternalClientServiceDeleteResponse = new ExternalClientServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceUpdateRequest$Type extends MessageType<ExternalClientServiceUpdateRequest> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceUpdateRequest", [
            { no: 1, name: "client", kind: "message", T: () => ExternalClientInfo, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceUpdateRequest
 */
export const ExternalClientServiceUpdateRequest = new ExternalClientServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceUpdateResponse$Type extends MessageType<ExternalClientServiceUpdateResponse> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceUpdateResponse", [
            { no: 1, name: "client", kind: "message", T: () => ExternalClientInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceUpdateResponse
 */
export const ExternalClientServiceUpdateResponse = new ExternalClientServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientSearchServiceSearchRequest$Type extends MessageType<ExternalClientSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "well_known_clients", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.iam.v1.WellKnownClient", WellKnownClient, "WELL_KNOWN_CLIENT_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientSearchServiceSearchRequest
 */
export const ExternalClientSearchServiceSearchRequest = new ExternalClientSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientSearchServiceSearchResponse$Type extends MessageType<ExternalClientSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalClientInfo },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientSearchServiceSearchResponse
 */
export const ExternalClientSearchServiceSearchResponse = new ExternalClientSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientGrantRef$Type extends MessageType<ExternalClientGrantRef> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientGrantRef", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientGrantRef
 */
export const ExternalClientGrantRef = new ExternalClientGrantRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.ExternalClientService
 */
export const ExternalClientService = new ServiceType("c1.api.iam.v1.ExternalClientService", [
    { name: "GetApprovalInfo", options: { "authz.method": { role: "VIEWER" } }, I: GetApprovalInfoRequest, O: GetApprovalInfoResponse },
    { name: "Approve", options: { "authz.method": { role: "EDITOR" } }, I: ApproveRequest, O: ApproveResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ExternalClientServiceListRequest, O: ExternalClientServiceListResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: ExternalClientServiceDeleteRequest, O: ExternalClientServiceDeleteResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: ExternalClientServiceUpdateRequest, O: ExternalClientServiceUpdateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.ExternalClientSearchService
 */
export const ExternalClientSearchService = new ServiceType("c1.api.iam.v1.ExternalClientSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/iam/external_clients", summary: "NOTE: Searches external client grants for all users", group: "External Client" }] } }, I: ExternalClientSearchServiceSearchRequest, O: ExternalClientSearchServiceSearchResponse }
]);
